export class SocketEvents {
  public static readonly CONNECT = 'connect';
  public static readonly DISCONNECT = 'disconnect';
  public static readonly INVENTORY_ERROR = 'INVENTORY_ERROR';
  public static readonly INVENTORY_FINISH = 'INVENTORY_FINISH';
  public static readonly INVENTORY_PROGRESS = 'INVENTORY_PROGRESS';
  public static readonly JOIN_CHANNEL = 'JOIN_CHANNEL';
  public static readonly LEAVE_CHANNELS = 'LEAVE_CHANNELS';
}
